// removed by extract-text-webpack-plugin
module.exports = {"pageResultDetails":"TogglePageCardList__pageResultDetails___13OoD","pageWrapper":"TogglePageCardList__pageWrapper___vkDgx","page":"TogglePageCardList__page___HJPAv"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/TogglePageCardList.css
// module id = 1571
// module chunks = 0